<template>
  <PaymentBox>
    <BoxContent
      :title="'Pagamento realizado com Sucesso'"
      :icon="'PixIcon'"
      :animated="true"
      :success="true"
    />
  </PaymentBox>
</template>

<script>
import PaymentBox from '@/components/layout/PaymentBox';
import BoxContent from '@/components/payments/BoxContent';
import { dataLayersMixin } from '@/utils/mixins';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'PaymentPix',
  components: {
    PaymentBox,
    BoxContent,
  },
  mixins: [dataLayersMixin],
  computed: {
    ...mapState({
      manuallySelectedExams: ({ searchExams }) => searchExams.data.manuallySelectedExams,
    }),
    ...mapGetters({
      isOnlinePaymentEnabled: 'global/isOnlinePaymentEnabled',
      isT2FlowAllowed: 'global/isT2FlowAllowed',
    }),
  },
  methods: {
    ...mapActions(['global/updateFlowSteps']),
    getNextRoute() {
      const paidButNotT2FlowAllowed = this.isOnlinePaymentEnabled && !this.isT2FlowAllowed;
      const t2FlowAllowedButNotScheduled = this.manuallySelectedExams.length > 0;

      const noNeedConfirmArrival = paidButNotT2FlowAllowed || t2FlowAllowedButNotScheduled;

      if (noNeedConfirmArrival) {
        return 'checkin-conclusion';
      }
      return 'checkin-conclusion-simple';
    },
  },
  async created() {
    this.mostCommonPagesAnalytics({
      step: 'seleção_cartão_ou_particular',
      screen: 'pagamento_aceito_pix',
      complementaryObject: {
        payment: {
          type: 'particular_com_pix',
        },
      },
    });

    await this['global/updateFlowSteps']([8, 2]);

    const nextRoute = this.getNextRoute();

    setTimeout(() => {
      this.$router.push({ name: nextRoute });
    }, 3000);
  },
};
</script>

<style lang="scss" scoped>
.payment__cp-area {
  background: #f6f6f6;
  border-radius: 8px;
  padding: 10px;
  margin: 16px 0;
  font-weight: 300;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  &-text {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 100%;
  }
}

.payment__timer-text {
  font-weight: 300;
  font-size: 14px;
  line-height: 170%;
  display: block;
  text-align: left;
}

.payment__timer-time {
  font-weight: 700;
  font-size: 20px;
  line-height: 120%;
  display: block;
  text-align: left;
}

.payment__progress-bar {
  background: #0234ec;
  border-radius: 0px 90px 90px 0px;
  width: 100%;
  height: 4px;
  margin-top: 8px;
}

.payment__timer {
  width: 100%;
  margin: 24px 0;

  &--end {
    & .payment__timer-time {
      color: var(--color-error);
    }

    .payment__progress-bar {
      background: var(--color-error);
    }
  }
}

.drawer__title {
  font-weight: 700;
  font-size: 20px;
  margin-bottom: 24px;
}

.drawer__list {
  color: #797c86;
  font-size: 16px;

  strong {
    font-weight: 700;
    display: block;
  }

  span {
    font-weight: 300;
  }

  li {
    display: block;
    // &:not:last-child() {
    margin-bottom: 24px;
    // }
  }
}
</style>
